module.exports = __webpack_public_path__ + "img/hb.68356772.jpg";